<template>
    <div>
        <SkeletonBase
            class="mt-3.5 hidden md:block"
            :content="1"
            has-divided
        />
        <SkeletonBase
            class="mt-3.5 md:hidden"
            :content="2"
            has-divided
        />
        <div
            v-for="n in 2"
            :key="n"
        >
            <SkeletonBase
                class="hidden md:block"
                has-title
                :table="2"
                has-button
                has-divided
            />
            <SkeletonBase
                class="md:hidden"
                has-title
                :content="3"
                has-button
                has-divided
            />
        </div>
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';

export default {
    components: {
        SkeletonBase
    },
};
</script>
